import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=1ee8a94a"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"
import style0 from "./Preference.vue?vue&type=style&index=0&id=1ee8a94a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports